<template>
  <div id="id-app-share">
    <!-- <div class="app-share-header" :style="'background:url('+bg+') no-repeat;background-size:100% 100%'"> -->
    <div class="app-share-header">
      <img class="app-share-header-bg" :src="bg" alt="" />
    </div>
    <div class="app-share-content" style="margin-bottom: 1rem">
      <section>
        <!-- <img class="logo" src="../../assets/img/logo@2x.png" alt="" /> -->
        <!-- <h2>鹏扬好基通</h2>
          <span>专业稳健 回报信任</span> -->
        <!-- @touchstart="touchstart" -->
        <!-- @touchend="touchend" @click="handleDownload" -->
        <div id="id-download" ref="BtnDown" :style="'background: url('+downBtn+');background-size: 100%;background-position: left top;'">
          <!-- 下载鹏扬好基通APP -->
        </div>
        <!-- <b>市场有风险 投资需谨慎</b> -->
      </section>
      <div class="app-share-content-item" v-for="(item, index) in list" :key="index">
        <img :src="item.imgUrl" alt="" />
        <h3>{{ item.title }}</h3>
        <span>{{ item.text1 }}</span>
        <span>{{ item.text2 }}</span>
      </div>
      <p class="tips">市场有风险 投资需谨慎</p>
    </div>
  </div>
</template>
<script>
  export default {
    name: '',
    data() {
      return {
        OpenInstallData:null,
        bg:'https://oss.pyamc.com/app_download/DownBg.png',
        downBtn:'https://oss.pyamc.com/app_download/down-btn.png',
        list: [{
          title: '专业投资平台',
          text1: '全国首家“私转公”',
          text2: '鹏扬倾情打造',
          imgUrl: 'https://oss.pyamc.com/app_download/TouZiPingTai.png'
        },
        {
          title: '开户简捷',
          text1: '强大的科技赋能',
          text2: '简化整体开户流程',
          imgUrl: 'https://oss.pyamc.com/app_download/KaiHuJianJie.png'
        },
        {
          title: '贴身服务',
          text1: '专业的服务团队',
          text2: '在线解答疑难问题',
          imgUrl: 'https://oss.pyamc.com/app_download/TieShenZhanShi.png'
        },
        {
          title: '轻松一键购',
          text1: '0费率购基',
          text2: '节约购买成本',
          imgUrl: 'https://oss.pyamc.com/app_download/QingSongYiJianGou.png'
        },
        {
          title: '全渠道持仓展示',
          text1: '一键查询全渠道资产',
          text2: '轻易掌握全局',
          imgUrl: 'https://oss.pyamc.com/app_download/ChiCangZhangShi.png'
        },
        {
          title: '精选好基',
          text1: '紧跟行情轻松投资',
          text2: '鹏扬出品必属精品',
          imgUrl: 'https://oss.pyamc.com/app_download/JingXuanHaoJi.png'
        }
      ]}
    },
    mounted() {
    this.OpenInstallData = OpenInstall.parseUrlParams()
    var button = this.$refs.BtnDown
      new OpenInstall({
          /* appKey必选参数，openinstall平台为每个应用分配的ID */
          appKey: 'akw0q7',
          /* 自定义遮罩的html */
          // mask:function(){
          //  return "<div id='_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
          // },
          /* OpenInstall初始化完成的回调函数，可选 */
          
          onready: function() {
            /* 在app已安装的情况尝试拉起app */
            this.schemeWakeup()
            // eslint-disable-next-line one-var
            var m = this
            button.onclick=function(){
              m.install()
              return false
            }
            
            // m.wakeupOrInstall()
            
          }
        }, this.OpenInstallData)
    
     document.title = '下载鹏扬好基通'
      // this.init()
    },
    methods: {
      touchstart(e) {
        e.target.style.backgroundColor = '#ef3c34'
        e.target.style.color = '#ffffff'
      },
      touchend(e) {
        this.$nextTick(() => {
          e.target.style.backgroundColor = '#ffffff'
          e.target.style.color = '#ef3c34'
        })
      },
      getOs() {
        let ua = navigator.userAgent
        let isWindowsPhone = /(?:Windows Phone)/.test(ua)
        let isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone
        let isAndroid = /(?:Android)/.test(ua)
        let isFireFox = /(?:Firefox)/.test(ua)
        // isChrome = /(?:Chrome|CriOS)/.test(ua),
        let isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox &&
          /(?:Tablet)/.test(ua))
        let isPhone = /(?:iPhone)/.test(ua) && !isTablet
        let isWeiXin = ua.toLowerCase().indexOf('micromessenger') !== -1
        let isPc = !isPhone && !isAndroid && !isSymbian
        return {
          isTablet: isTablet,
          isPhone: isPhone,
          isAndroid: isAndroid,
          isPc: isPc,
          isWeiXin
        }
      },
      handleDownload() {
        // MessageBox({
        //   title: '',
        //   message: '可能离开微信，打开第三方应用',
        //   showCancelButton: true,
        //   confirmButtonText: '继续',
        //   cancelButtonText: '取消'
        // })

        // let os = this.getOs()
        // alert(JSON.stringify(o, null, 2))
        // if (os.isAndroid) {
        //   //
        //   alert('isAndroid')
        // } else if (os.isPhone) {
        //   //
        //   alert('isPhone')
        // } else if (os.isWeiXin) {
        //   //
        //   alert('isWeiXin')
        //   window.location.href = 'weixin://scanqrcode'
        // }
        // OpenInstall初始化时将与openinstall服务器交互，应尽可能早的调用
        // var data = OpenInstall.parseUrlParams() /// openinstall.js中提供的工具函数，解析url中的所有查询参数
        // eslint-disable-next-line no-new
        new OpenInstall({
          /* appKey必选参数，openinstall平台为每个应用分配的ID */
          appKey: 'akw0q7',
          /* 自定义遮罩的html */
          // mask:function(){
          //  return "<div id='_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
          // },
          /* OpenInstall初始化完成的回调函数，可选 */
          onready: function() {
            /* 在app已安装的情况尝试拉起app */
            // this.schemeWakeup()
            // eslint-disable-next-line one-var
            var m = this
            // m.wakeupOrInstall()
            m.install()
            return false
          }
        }, this.OpenInstallData)
      },
      // ios 8 之前 和 android
      jumpIosAppStore() {
        location.href = 'weixin://'
      }
    }
  }
</script>
<style lang="scss" scoped>
  #id-app-share {
    background-color: #d91600;
    padding-bottom: 10px;

    .app-share-header {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      height: 9.3rem;
      .app-share-header-bg {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        // height: 10.4rem;
        z-index: 1;
      }


    }

    .app-share-content {
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 1.6rem;
      background-color: #fff;
      margin: 0.6rem 0.4rem 0.8rem 0.4rem;
      border-radius: 0.94rem;
      margin-bottom: 50px;
      background-size: 100% 100%;
      section {
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 2;
        width: 100%;

        .logo {
          width: 2.213rem;
          height: 2.213rem;
          margin-bottom: 0.373rem;
        }

        h2 {
          margin-bottom: 0.16rem;
          font-family: PingFangSC-Medium, sans-serif;
          font-size: 0.587rem;
          color: #ffffff;
          line-height: 0.64rem;
          font-weight: bold;
        }

        span {
          margin-bottom: 1.44rem;
          font-family: PingFangSC-Regular, sans-serif;
          font-size: 0.347rem;
          color: rgba(255, 255, 255, 0.65);
          line-height: 0.56rem;
          font-weight: 400;
        }

        #id-download {
          width: 82%;
          height: 1.7rem;
          line-height: 1.7rem;
          /* margin-bottom: 0.16rem; */
          text-align: center;
          font-family: PingFangSC-Regular, sans-serif;
          font-size: 0.427rem;
          color: #fff;
          font-weight: 400;
          margin-top: 0.8rem;
          
          /* border-radius: 25px; */
        }

        b {
          font-family: PingFangSC-Regular, sans-serif;
          font-size: 0.293rem;
          color: rgba(255, 255, 255, 0.65);
          line-height: 0.507rem;
          font-weight: 400;
        }
      }

      .tips {
        font-family: PingFangSC-Regular;
        font-size: 10px;
        color: rgba(0, 0, 0, 0.55);
        display: block;
        width: 100%;
        text-align: center;
        margin-top: 20px;
      }

      .app-share-content-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 50%;

        img {
          height: 1.786rem;
          width: 1.786rem;
          margin: 0.8rem 0 0.4rem 0;
        }

        h3 {
          margin-bottom: 0.133rem;
          font-family: PingFangSC-Medium, sans-serif;
          font-size: 0.427rem;
          color: #333333;
          line-height: 0.64rem;
          font-weight: bold;
        }

        span {
          font-family: PingFangSC-Medium, sans-serif;
          font-size: 0.32rem;
          color: #666666;
          text-align: center;
          line-height: 0.48rem;
          font-weight: 400;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/AppShare.vue